// ===== 翻译映射对象 =====
const variantOptionTranslations = {
  fr: {
    'Skirt Length Type': {
      'Mini': 'Mini',
      'Midi': 'Midi',
      'Maxi': 'Maxi'
    },
    'Pants Length Type': {
      'Ankle Length': 'Longueur cheville',
      'Shorts / Bermuda': 'Shorts / Bermuda',
      'Hot Pants / Mini': 'Hot pants / Mini',
      'Capri (6/7)': 'Capri (6/7)',
      'Cropped (8)': 'Court (8)',
      'Extra Long': 'Très longue',
      'Full-Length': 'Longueur standard'
    },
    'Color': {
      'Light Blue': 'Bleu clair',
      'Distressed Blue': 'Bleu délavé',
      'Blue': 'Bleu',
      'Denim Blue': 'Bleu denim',
      'Dark Wash Blue': 'Bleu foncé wash',
      'Light Wash Blue': 'Bleu clair wash',
      'Mid-Wash Blue': 'Bleu moyen wash',
      'Teal Blue': 'Bleu sarcelle',
      'Dark Indigo Wash': 'Bleu indigo foncé',
      'Deep Indigo': 'Bleu nuit',
      'Blue Gray': 'Gris bleuté',
      'White': 'Blanc',
      'Ivory': 'Ivoire',
      'Taupe': 'Taupe',
      'Solid Black': 'Noir profond',
      'Charcoal': 'Gris anthracite',
      'Classic Gray': 'Gris classique',
      'Moonlight Gray': 'Gris clair de lune',
      'Oatmeal Gray': 'Gris avoine',
      'Concrete Gray': 'Gris ciment',
      'Taupe Gray': 'Gris taupe',
      'Tan': 'Tan',
      'Cream': 'Crème',
      'Butter Yellow': 'Jaune beurre',
      'Espresso': 'Brun espresso',
      'Camouflage': 'Camouflage',
      'Vintage Blue': 'Bleu vintage',
      'Light Blue(Fleece-Lined)': 'Bleu clair(Doublure polaire)',
      'Distressed Blue(Fleece-Lined)': 'Bleu délavé(Doublure polaire)',
      'Blue(Fleece-Lined)': 'Bleu(Doublure polaire)',
      'Denim Blue(Fleece-Lined)': 'Bleu denim(Doublure polaire)',
      'Dark Wash Blue(Fleece-Lined)': 'Bleu foncé wash(Doublure polaire)',
      'Light Wash Blue(Fleece-Lined)': 'Bleu clair wash(Doublure polaire)',
      'Mid-Wash Blue(Fleece-Lined)': 'Bleu moyen wash(Doublure polaire)',
      'Teal Blue(Fleece-Lined)': 'Bleu sarcelle(Doublure polaire)',
      'Dark Indigo Wash(Fleece-Lined)': 'Bleu indigo foncé(Doublure polaire)',
      'Deep Indigo(Fleece-Lined)': 'Bleu nuit(Doublure polaire)',
      'Blue Gray(Fleece-Lined)': 'Gris bleuté(Doublure polaire)',
      'White(Fleece-Lined)': 'Blanc(Doublure polaire)',
      'Ivory(Fleece-Lined)': 'Ivoire(Doublure polaire)',
      'Taupe(Fleece-Lined)': 'Taupe(Doublure polaire)',
      'Solid Black(Fleece-Lined)': 'Noir profond(Doublure polaire)',
      'Charcoal(Fleece-Lined)': 'Gris anthracite(Doublure polaire)',
      'Classic Gray(Fleece-Lined)': 'Gris classique(Doublure polaire)',
      'Moonlight Gray(Fleece-Lined)': 'Gris clair de lune(Doublure polaire)',
      'Oatmeal Gray(Fleece-Lined)': 'Gris avoine(Doublure polaire)',
      'Concrete Gray(Fleece-Lined)': 'Gris ciment(Doublure polaire)',
      'Taupe Gray(Fleece-Lined)': 'Gris taupe(Doublure polaire)',
      'Tan(Fleece-Lined)': 'Tan(Doublure polaire)',
      'Cream(Fleece-Lined)': 'Crème(Doublure polaire)',
      'Butter Yellow(Fleece-Lined)': 'Jaune beurre(Doublure polaire)',
      'Espresso(Fleece-Lined)': 'Brun espresso(Doublure polaire)',
      'Camouflage(Fleece-Lined)': 'Camouflage(Doublure polaire)',
      'Vintage Blue(Fleece-Lined)': 'Bleu vintage(Doublure polaire)'
    }
  },
  he: {
    'Skirt Length Type': {
      'Mini': 'מיני',
      'Midi': 'מידי',
      'Maxi': 'מקסי'
    },
    'Pants Length Type': {
      'Ankle Length': 'אורך קרסול',
      'Shorts / Bermuda': 'שורטס / ברמודה',
      'Hot Pants / Mini': 'הוט פנטס / מיני',
      'Capri (6/7)': 'קפרי (6/7)',
      'Cropped (8)': 'קצוץ (8)',
      'Extra Long': 'ארוך במיוחד',
      'Full-Length': 'אורך מלא'
    },
    'Color': {
      'Light Blue': 'כחול בהיר',
      'Distressed Blue': 'כחול משופשף',
      'Blue': 'כחול',
      'Denim Blue': 'כחול דנים',
      'Dark Wash Blue': 'כחול כהה wash',
      'Light Wash Blue': 'כחול בהיר wash',
      'Mid-Wash Blue': 'כחול קלאסי',
      'Teal Blue': 'כחול טורקיז',
      'Dark Indigo Wash': 'כחול אינדיגו כהה',
      'Deep Indigo': 'כחול עמוק',
      'Blue Gray': 'כחול אפור',
      'White': 'לבן',
      'Ivory': 'לבן שמנת',
      'Taupe': 'חום טופ',
      'Solid Black': 'שחור פחם',
      'Charcoal': 'אפור פחם',
      'Classic Gray': 'אפור',
      'Moonlight Gray': 'אפור אור ירח',
      'Oatmeal Gray': 'אפור שיבולת שועל',
      'Concrete Gray': 'אפור מלט',
      'Taupe Gray': 'אפור טופ',
      'Tan': 'חאקי-טאן',
      'Cream': 'שמנת',
      'Butter Yellow': 'צהוב חמאה',
      'Espresso': 'חום אספרסו',
      'Camouflage': 'הסוואה',
      'Vintage Blue': "כחול וינטג'",
      'Light Blue(Fleece-Lined)': 'כחול בהיר(בטנת פליס)',
      'Distressed Blue(Fleece-Lined)': 'כחול משופשף(בטנת פליס)',
      'Blue(Fleece-Lined)': 'כחול(בטנת פליס)',
      'Denim Blue(Fleece-Lined)': 'כחול דנים(בטנת פליס)',
      'Dark Wash Blue(Fleece-Lined)': 'כחול כהה wash(בטנת פליס)',
      'Light Wash Blue(Fleece-Lined)': 'כחול בהיר wash(בטנת פליס)',
      'Mid-Wash Blue(Fleece-Lined)': 'כחול קלאסי(בטנת פליס)',
      'Teal Blue(Fleece-Lined)': 'כחול טורקיז(בטנת פליס)',
      'Dark Indigo Wash(Fleece-Lined)': 'כחול אינדיגו כהה(בטנת פליס)',
      'Deep Indigo(Fleece-Lined)': 'כחול עמוק(בטנת פליס)',
      'Blue Gray(Fleece-Lined)': 'כחול אפור(בטנת פליס)',
      'White(Fleece-Lined)': 'לבן(בטנת פליס)',
      'Ivory(Fleece-Lined)': 'לבן שמנת(בטנת פליס)',
      'Taupe(Fleece-Lined)': 'חום טופ(בטנת פליס)',
      'Solid Black(Fleece-Lined)': 'שחור פחם(בטנת פליס)',
      'Charcoal(Fleece-Lined)': 'אפור פחם(בטנת פליס)',
      'Classic Gray(Fleece-Lined)': 'אפור(בטנת פליס)',
      'Moonlight Gray(Fleece-Lined)': 'אפור אור ירח(בטנת פליס)',
      'Oatmeal Gray(Fleece-Lined)': 'אפור שיבולת שועל(בטנת פליס)',
      'Concrete Gray(Fleece-Lined)': 'אפור מלט(בטנת פליס)',
      'Taupe Gray(Fleece-Lined)': 'אפור טופ(בטנת פליס)',
      'Tan(Fleece-Lined)': 'חאקי-טאן(בטנת פליס)',
      'Cream(Fleece-Lined)': 'שמנת(בטנת פליס)',
      'Butter Yellow(Fleece-Lined)': 'צהוב חמאה(בטנת פליס)',
      'Espresso(Fleece-Lined)': 'חום אספרסו(בטנת פליס)',
      'Camouflage(Fleece-Lined)': 'הסוואה(בטנת פליס)',
      'Vintage Blue(Fleece-Lined)': "כחול וינטג'(בטנת פליס)"
    }
  },
  ja: {
    'Skirt Length Type': {
      'Mini': 'ミニ',
      'Midi': 'ミディ',
      'Maxi': 'マキシ'
    },
    'Pants Length Type': {
      'Ankle Length': 'アンクルレングス',
      'Shorts / Bermuda': 'ショーツ / バミューダ',
      'Hot Pants / Mini': 'ホットパンツ / ミニ',
      'Capri (6/7)': 'カプリ (6/7)',
      'Cropped (8)': 'クロップド (8)',
      'Extra Long': 'エクストラロング',
      'Full-Length': 'フルレングス'
    },
    'Color': {
      'Light Blue': 'ライトブルー',
      'Distressed Blue': 'ユーズド風ブルー',
      'Blue': 'ブルー',
      'Denim Blue': 'デニムブルー',
      'Dark Wash Blue': 'ダークウォッシュブルー',
      'Light Wash Blue': 'ライトウォッシュブルー',
      'Mid-Wash Blue': 'ミディアムウォッシュ',
      'Teal Blue': 'ティールブルー',
      'Dark Indigo Wash': 'ダークインディゴ',
      'Deep Indigo': 'ディープインディゴ',
      'Blue Gray': 'ブルーグレー',
      'White': 'ホワイト',
      'Ivory': 'アイボリー',
      'Taupe': 'グレージュ',
      'Solid Black': 'ソリッドブラック',
      'Charcoal': 'チャコール',
      'Classic Gray': 'グレー',
      'Moonlight Gray': 'ムーンライトグレー',
      'Oatmeal Gray': 'オートミールグレー',
      'Concrete Gray': 'セメントグレー',
      'Taupe Gray': 'グレージュグレー',
      'Tan': 'タン',
      'Cream': 'クリーム',
      'Butter Yellow': 'バターイエロー',
      'Espresso': 'ダークブラウン',
      'Camouflage': 'カモフラージュ',
      'Vintage Blue': 'ヴィンテージブルー',
      'Light Blue(Fleece-Lined)': 'ライトブルー(裏起毛)',
      'Distressed Blue(Fleece-Lined)': 'ユーズド風ブルー(裏起毛)',
      'Blue(Fleece-Lined)': 'ブルー(裏起毛)',
      'Denim Blue(Fleece-Lined)': 'デニムブルー(裏起毛)',
      'Dark Wash Blue(Fleece-Lined)': 'ダークウォッシュブルー(裏起毛)',
      'Light Wash Blue(Fleece-Lined)': 'ライトウォッシュブルー(裏起毛)',
      'Mid-Wash Blue(Fleece-Lined)': 'ミディアムウォッシュ(裏起毛)',
      'Teal Blue(Fleece-Lined)': 'ティールブルー(裏起毛)',
      'Dark Indigo Wash(Fleece-Lined)': 'ダークインディゴ(裏起毛)',
      'Deep Indigo(Fleece-Lined)': 'ディープインディゴ(裏起毛)',
      'Blue Gray(Fleece-Lined)': 'ブルーグレー(裏起毛)',
      'White(Fleece-Lined)': 'ホワイト(裏起毛)',
      'Ivory(Fleece-Lined)': 'アイボリー(裏起毛)',
      'Taupe(Fleece-Lined)': 'グレージュ(裏起毛)',
      'Solid Black(Fleece-Lined)': 'ソリッドブラック(裏起毛)',
      'Charcoal(Fleece-Lined)': 'チャコール(裏起毛)',
      'Classic Gray(Fleece-Lined)': 'グレー(裏起毛)',
      'Moonlight Gray(Fleece-Lined)': 'ムーンライトグレー(裏起毛)',
      'Oatmeal Gray(Fleece-Lined)': 'オートミールグレー(裏起毛)',
      'Concrete Gray(Fleece-Lined)': 'セメントグレー(裏起毛)',
      'Taupe Gray(Fleece-Lined)': 'グレージュグレー(裏起毛)',
      'Tan(Fleece-Lined)': 'タン(裏起毛)',
      'Cream(Fleece-Lined)': 'クリーム(裏起毛)',
      'Butter Yellow(Fleece-Lined)': 'バターイエロー(裏起毛)',
      'Espresso(Fleece-Lined)': 'ダークブラウン(裏起毛)',
      'Camouflage(Fleece-Lined)': 'カモフラージュ(裏起毛)',
      'Vintage Blue(Fleece-Lined)': 'ヴィンテージブルー(裏起毛)'
    }
  },
  ko: {
    'Skirt Length Type': {
      'Mini': '미니',
      'Midi': '미디',
      'Maxi': '맥시'
    },
    'Pants Length Type': {
      'Ankle Length': '앵클 렝스',
      'Shorts / Bermuda': '쇼츠 / 버뮤다',
      'Hot Pants / Mini': '핫팬츠 / 미니',
      'Capri (6/7)': '카프리 (6/7)',
      'Cropped (8)': '크롭 (8)',
      'Extra Long': '엑스트라 롱',
      'Full-Length': '풀 렝스'
    },
    'Color': {
      'Light Blue': '라이트 블루',
      'Distressed Blue': '빈티지 워시 블루',
      'Blue': '블루',
      'Denim Blue': '데님 블루',
      'Dark Wash Blue': '진청',
      'Light Wash Blue': '연청',
      'Mid-Wash Blue': '중청',
      'Teal Blue': '티얼 블루',
      'Dark Indigo Wash': '딥 인디고 워시',
      'Deep Indigo': '딥 인디고',
      'Blue Gray': '블루 그레이',
      'White': '화이트',
      'Ivory': '아이보리',
      'Taupe': '토프',
      'Solid Black': '솔리드 블랙',
      'Charcoal': '차콜',
      'Classic Gray': '그레이',
      'Moonlight Gray': '문라이트 그레이',
      'Oatmeal Gray': '오트밀 그레이',
      'Concrete Gray': '시멘트 그레이',
      'Taupe Gray': '토프 그레이',
      'Tan': '탄',
      'Cream': '크림',
      'Butter Yellow': '버터 옐로우',
      'Espresso': '에스프레소 브라운',
      'Camouflage': '카모플라주',
      'Vintage Blue': '빈티지 블루',
      'Light Blue(Fleece-Lined)': '라이트 블루(기모 안감)',
      'Distressed Blue(Fleece-Lined)': '빈티지 워시 블루(기모 안감)',
      'Blue(Fleece-Lined)': '블루(기모 안감)',
      'Denim Blue(Fleece-Lined)': '데님 블루(기모 안감)',
      'Dark Wash Blue(Fleece-Lined)': '진청(기모 안감)',
      'Light Wash Blue(Fleece-Lined)': '연청(기모 안감)',
      'Mid-Wash Blue(Fleece-Lined)': '중청(기모 안감)',
      'Teal Blue(Fleece-Lined)': '티얼 블루(기모 안감)',
      'Dark Indigo Wash(Fleece-Lined)': '딥 인디고 워시(기모 안감)',
      'Deep Indigo(Fleece-Lined)': '딥 인디고(기모 안감)',
      'Blue Gray(Fleece-Lined)': '블루 그레이(기모 안감)',
      'White(Fleece-Lined)': '화이트(기모 안감)',
      'Ivory(Fleece-Lined)': '아이보리(기모 안감)',
      'Taupe(Fleece-Lined)': '토프(기모 안감)',
      'Solid Black(Fleece-Lined)': '솔리드 블랙(기모 안감)',
      'Charcoal(Fleece-Lined)': '차콜(기모 안감)',
      'Classic Gray(Fleece-Lined)': '그레이(기모 안감)',
      'Moonlight Gray(Fleece-Lined)': '문라이트 그레이(기모 안감)',
      'Oatmeal Gray(Fleece-Lined)': '오트밀 그레이(기모 안감)',
      'Concrete Gray(Fleece-Lined)': '시멘트 그레이(기모 안감)',
      'Taupe Gray(Fleece-Lined)': '토프 그레이(기모 안감)',
      'Tan(Fleece-Lined)': '탄(기모 안감)',
      'Cream(Fleece-Lined)': '크림(기모 안감)',
      'Butter Yellow(Fleece-Lined)': '버터 옐로우(기모 안감)',
      'Espresso(Fleece-Lined)': '에스프레소 브라운(기모 안감)',
      'Camouflage(Fleece-Lined)': '카모플라주(기모 안감)',
      'Vintage Blue(Fleece-Lined)': '빈티지 블루(기모 안감)'
    }
  },
  'zh-cn': {
    'Skirt Length Type': {
      'Mini': '短裙',
      'Midi': '中裙',
      'Maxi': '长裙'
    },
    'Pants Length Type': {
      'Ankle Length': '九分',
      'Shorts / Bermuda': '短裤 / 百慕大',
      'Hot Pants / Mini': '热裤 / 迷你',
      'Capri (6/7)': '六/七分裤',
      'Cropped (8)': '八分裤',
      'Extra Long': '加长',
      'Full-Length': '全长'
    },
    'Color': {
      'Light Blue': '浅蓝',
      'Distressed Blue': '水洗蓝',
      'Blue': '蓝色',
      'Denim Blue': '牛仔蓝',
      'Dark Wash Blue': '深蓝',
      'Light Wash Blue': '天空蓝',
      'Mid-Wash Blue': '怀旧蓝',
      'Teal Blue': '湖蓝',
      'Dark Indigo Wash': '黑金蓝',
      'Deep Indigo': '水晶深蓝',
      'Blue Gray': '蓝灰',
      'White': '白色',
      'Ivory': '米白',
      'Taupe': '奶茶色',
      'Solid Black': '黑色',
      'Charcoal': '炭灰',
      'Classic Gray': '灰色',
      'Moonlight Gray': '月光灰',
      'Oatmeal Gray': '米灰',
      'Concrete Gray': '水泥灰',
      'Taupe Gray': '奶茶灰',
      'Tan': '卡其色',
      'Cream': '杏色',
      'Butter Yellow': '奶油黄',
      'Espresso': '咖啡棕',
      'Camouflage': '迷彩',
      'Vintage Blue': '复古蓝',
      'Light Blue(Fleece-Lined)': '浅蓝(加绒)',
      'Distressed Blue(Fleece-Lined)': '水洗蓝(加绒)',
      'Blue(Fleece-Lined)': '蓝色(加绒)',
      'Denim Blue(Fleece-Lined)': '牛仔蓝(加绒)',
      'Dark Wash Blue(Fleece-Lined)': '深蓝(加绒)',
      'Light Wash Blue(Fleece-Lined)': '天空蓝(加绒)',
      'Mid-Wash Blue(Fleece-Lined)': '怀旧蓝(加绒)',
      'Teal Blue(Fleece-Lined)': '湖蓝(加绒)',
      'Dark Indigo Wash(Fleece-Lined)': '黑金蓝(加绒)',
      'Deep Indigo(Fleece-Lined)': '水晶深蓝(加绒)',
      'Blue Gray(Fleece-Lined)': '蓝灰(加绒)',
      'White(Fleece-Lined)': '白色(加绒)',
      'Ivory(Fleece-Lined)': '米白(加绒)',
      'Taupe(Fleece-Lined)': '奶茶色(加绒)',
      'Solid Black(Fleece-Lined)': '黑色(加绒)',
      'Charcoal(Fleece-Lined)': '炭灰(加绒)',
      'Classic Gray(Fleece-Lined)': '灰色(加绒)',
      'Moonlight Gray(Fleece-Lined)': '月光灰(加绒)',
      'Oatmeal Gray(Fleece-Lined)': '米灰(加绒)',
      'Concrete Gray(Fleece-Lined)': '水泥灰(加绒)',
      'Taupe Gray(Fleece-Lined)': '奶茶灰(加绒)',
      'Tan(Fleece-Lined)': '卡其色(加绒)',
      'Cream(Fleece-Lined)': '杏色(加绒)',
      'Butter Yellow(Fleece-Lined)': '奶油黄(加绒)',
      'Espresso(Fleece-Lined)': '咖啡棕(加绒)',
      'Camouflage(Fleece-Lined)': '迷彩(加绒)',
      'Vintage Blue(Fleece-Lined)': '复古蓝(加绒)'
    }
  },
  'zh-tw': {
    'Skirt Length Type': {
      'Mini': '短裙',
      'Midi': '中裙',
      'Maxi': '長裙'
    },
    'Pants Length Type': {
      'Ankle Length': '九分',
      'Shorts / Bermuda': '短褲 / 百慕達',
      'Hot Pants / Mini': '熱褲 / 迷你',
      'Capri (6/7)': '六/七分褲',
      'Cropped (8)': '八分褲',
      'Extra Long': '加長',
      'Full-Length': '全長'
    },
    'Color': {
      'Light Blue': '淺藍色',
      'Distressed Blue': '做舊水洗藍',
      'Blue': '藍色',
      'Denim Blue': '牛仔藍',
      'Dark Wash Blue': '深洗水藍',
      'Light Wash Blue': '淺洗水藍',
      'Mid-Wash Blue': '經典水洗藍',
      'Teal Blue': '湖水藍',
      'Dark Indigo Wash': '黑金深靛藍',
      'Deep Indigo': '深靛藍',
      'Blue Gray': '藍灰色',
      'White': '白色',
      'Ivory': '象牙米白',
      'Taupe': '奶茶燕麥色',
      'Solid Black': '極致黑色',
      'Charcoal': '炭灰色',
      'Classic Gray': '經典灰色',
      'Moonlight Gray': '月光灰色',
      'Oatmeal Gray': '燕麥米灰',
      'Concrete Gray': '水泥灰色',
      'Taupe Gray': '奶茶米灰色',
      'Tan': '淺褐卡其',
      'Cream': '温柔杏色',
      'Butter Yellow': '奶油黃色',
      'Espresso': '濃醇咖啡棕',
      'Camouflage': '迷彩',
      'Vintage Blue': '復古藍',
      'Light Blue(Fleece-Lined)': '淺藍色(加絨)',
      'Distressed Blue(Fleece-Lined)': '做舊水洗藍(加絨)',
      'Blue(Fleece-Lined)': '藍色(加絨)',
      'Denim Blue(Fleece-Lined)': '牛仔藍(加絨)',
      'Dark Wash Blue(Fleece-Lined)': '深洗水藍(加絨)',
      'Light Wash Blue(Fleece-Lined)': '淺洗水藍(加絨)',
      'Mid-Wash Blue(Fleece-Lined)': '經典水洗藍(加絨)',
      'Teal Blue(Fleece-Lined)': '湖水藍(加絨)',
      'Dark Indigo Wash(Fleece-Lined)': '黑金深靛藍(加絨)',
      'Deep Indigo(Fleece-Lined)': '深靛藍(加絨)',
      'Blue Gray(Fleece-Lined)': '藍灰色(加絨)',
      'White(Fleece-Lined)': '白色(加絨)',
      'Ivory(Fleece-Lined)': '象牙米白(加絨)',
      'Taupe(Fleece-Lined)': '奶茶燕麥色(加絨)',
      'Solid Black(Fleece-Lined)': '極致黑色(加絨)',
      'Charcoal(Fleece-Lined)': '炭灰色(加絨)',
      'Classic Gray(Fleece-Lined)': '經典灰色(加絨)',
      'Moonlight Gray(Fleece-Lined)': '月光灰色(加絨)',
      'Oatmeal Gray(Fleece-Lined)': '燕麥米灰(加絨)',
      'Concrete Gray(Fleece-Lined)': '水泥灰色(加絨)',
      'Taupe Gray(Fleece-Lined)': '奶茶米灰色(加絨)',
      'Tan(Fleece-Lined)': '淺褐卡其(加絨)',
      'Cream(Fleece-Lined)': '温柔杏色(加絨)',
      'Butter Yellow(Fleece-Lined)': '奶油黃色(加絨)',
      'Espresso(Fleece-Lined)': '濃醇咖啡棕(加絨)',
      'Camouflage(Fleece-Lined)': '迷彩(加絨)',
      'Vintage Blue(Fleece-Lined)': '復古藍(加絨)'
    }
  }
};

// 别名映射
const variantOptionLocaleAliases = {
  'zh-hans': 'zh-cn',
  'zh-hant': 'zh-tw'
};

// ===== 缓存 locale，多时机初始化确保正确赋值 =====
let cachedLocale = (document.documentElement.lang || '').toLowerCase() || 'en';
document.addEventListener('DOMContentLoaded', () => {
  cachedLocale = (document.documentElement.lang || '').toLowerCase() || 'en';
});
document.addEventListener('readystatechange', () => {
  if (document.readyState === 'complete') {
    cachedLocale = (document.documentElement.lang || '').toLowerCase() || 'en';
  }
});



// ===== 以下为原 global.js 内容（VariantSelects 类中已优化翻译逻辑） =====

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;
    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return;
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER',
    'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
    if (mouseClick) return;
    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');
  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;
  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) return;
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};
  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);
  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));
  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },
  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },
  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);
    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }
      this.provinceContainer.style.display = '';
    }
  },
  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },
  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;
    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;
    const handleAnimation = (time) => {
      if (animationStart === undefined) animationStart = time;
      const elapsedTime = time - animationStart;
      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };
    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        deferredElement.play();
      }
      const formerStyle = deferredElement.getAttribute('style');
      deferredElement.setAttribute('style', 'display: block;');
      window.setTimeout(() => {
        deferredElement.setAttribute('style', formerStyle);
      }, 0);
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (!this.slider || !this.nextButton) return;
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1],
        },
      }));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({ left: position });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });
      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener('click', () => {
          this.announcementBarArrowButtonWasClicked = true;
        }, { once: true });
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);
    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({ left: position });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');
    if (!this.sliderControlButtons.length) return;
    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;
    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => { button.removeAttribute('tabindex'); });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => { button.setAttribute('tabindex', '-1'); });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;
    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;
    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;
    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({ left: slideScrollPosition });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.translateOptionValue = this.translateOptionValue.bind(this);
  }

  connectedCallback() {
  // 延迟初始化，确保 cachedLocale 已正确赋值
  setTimeout(() => {
  console.log('cachedLocale:', cachedLocale); // 加这行
  this.querySelectorAll('fieldset input:checked').forEach((input) => {
    console.log('input.value:', input.value, 'input.name:', input.name); // 加这行
    const selectedSwatchValue = input.closest('.product-form__input')?.querySelector('[data-selected-value]');
    if (selectedSwatchValue) {
      const optionName = input.name.trim().replace(/-\d+$/, '').trim() || '';
      const translated = this.translateOptionValue(input.value, optionName);
      console.log('translated:', translated); // 加这行
      selectedSwatchValue.innerHTML = translated;
    }
  });
}, 100);


  this.addEventListener('change', (event) => {
    const target = this.getInputForEventTarget(event.target);
    this.updateSelectionMetadata(event);
    publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
      data: {
        event,
        target,
        selectedOptionValues: this.selectedOptionValues,
      },
    });
  });
}



 translateOptionValue(value, optionName) {
  const nameMap = {
  'Couleur':'Color','צבע':'Color','カラー':'Color','컬러':'Color','颜色':'Color','顏色':'Color',
  'Longueur du pantalon':'Pants Length Type','סוג אורך מכנס':'Pants Length Type','パンツ丈':'Pants Length Type','바지 기장 타입':'Pants Length Type','裤长':'Pants Length Type','褲長':'Pants Length Type',
  'Longueur de la jupe':'Skirt Length Type','סוג אורך חצאית':'Skirt Length Type','スカート丈':'Skirt Length Type','스커트 기장 타입':'Skirt Length Type','裙长':'Skirt Length Type','裙長':'Skirt Length Type'
};
optionName = nameMap[optionName] || optionName;

  if (!optionName || optionName === 'Size') return value;

  let locale = cachedLocale || 'en';
  if (variantOptionLocaleAliases[locale]) {
    locale = variantOptionLocaleAliases[locale];
  }

  const optionMap = variantOptionTranslations[locale];
  if (!optionMap) return value;

  const valueMap = optionMap[optionName];
  if (!valueMap) return value;

  // 1. 英文key直接查
  if (valueMap[value] !== undefined) return valueMap[value];

  // 2. 已是当前语言翻译值，直接透传
  if (Object.values(valueMap).includes(value)) return value;

  // 3. 跨语言反向查找
  for (const lang of Object.keys(variantOptionTranslations)) {
    const langMap = variantOptionTranslations[lang]?.[optionName];
    if (!langMap) continue;
    if (Object.values(langMap).includes(value)) {
      const englishKey = Object.keys(langMap).find(k => langMap[k] === value);
      if (englishKey && valueMap[englishKey]) return valueMap[englishKey];
      return value;
    }
  }

  return value;
}


  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
} else if (tagName === 'INPUT' && target.type === 'radio') {
  const fieldset = target.closest('.product-form__input');
  const selectedSwatchValue = fieldset?.querySelector('[data-selected-value]');
  if (selectedSwatchValue) {
    // 从 fieldset 的 legend 读取 option 名称，不依赖 input.name 格式
    const legend = fieldset?.querySelector('legend');
const optionName = target.name.trim().replace(/-\d+$/, '').trim() || '';
    console.log('🔍 optionName:', JSON.stringify(optionName));  
    const translated = this.translateOptionValue(value, optionName);
    selectedSwatchValue.innerHTML = translated;
  }
}



}



  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');
        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }
        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();
    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 250;

  constructor() {
    super();
    this.queue = [];
    this.setRequestStarted(false);
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });
    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, BulkAdd.ASYNC_REQUEST_DELAY);
  }

  sendRequest(queue) {
    this.setRequestStarted(true);
    const items = {};
    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
    this.updateMultipleQty(items);
  }

  setRequestStarted(requestStarted) {
    this._requestStarted = requestStarted;
  }

  get requestStarted() {
    return this._requestStarted;
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      event.target.setAttribute('value', inputValue);
      this.startQueue(index, inputValue);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

class CartPerformance {
  static #metric_prefix = "cart-performance"

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    });
    const endMarker = performance.mark(`${metricName}:end`);
    performance.measure(metricName, `${metricName}:start`, `${metricName}:end`);
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`);
    performance.measure(metricName, startMarker.name, `${metricName}:end`);
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`);
    callback();
    const endMarker = performance.mark(`${metricName}:end`);
    performance.measure(metricName, `${metricName}:start`, `${metricName}:end`);
  }
}